import React from 'react';
import {useNavigate} from "react-router-dom";
import MikvahSlider from '../../../components/Mikvahslider/MikvahSlider';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import storylogo from '../../../assets/home/belz-logo.png';
import './CustomerStory.scss';
import { useTranslation } from 'react-i18next';

const CustomerStory = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const goToPage = (page) => {
        navigate(page, { replace: true });
    };
    return (
        <>
            <section className="customer-story-sec">
                <div className="container">
                    <div className="customer-story-wrapper">
                        <div className="top-header">
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={ () => { goToPage('/customer-stories')}}>
                                    Customer Stories 
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active onClick={ () => { goToPage('/')}}>
                                  Bais Fraida Mikvah
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className="customer-story-content">
                            <div className="customer-story-content-wrap">
                                <div className="left-content">
                                    <div className="story-plans">
                                        <div className="story-logo">
                                            <img src={storylogo} alt="storylogo" />
                                        </div>
                                        <div className="story-items">
                                            <div className="story-item">
                                                <span>Location</span>
                                                <h5>Jerusalem, Israel</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Size</span>
                                                <h5>3000+ Monthly Visitors</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Stage</span>
                                                <h5>New Mikvah</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Plan</span>
                                                <h5>Full Service</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Systems used</span>
                                                <ul>
                                                    <li>Reservation System</li>
                                                    <li>Auto Scheduling</li>
                                                    <li>{t("IntDisp")}</li>
                                                    <li>Live Dashboard</li>
                                                    <li>Guidance System</li>
                                                    <li>Door Control</li>
                                                    <li>Mikvah Website</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="right-content">
                                    <div className="story-details">
                                        <div className="story-heading">
                                            <h2 className='heading'>Yerushalyim’s Bais Fraida Belz Mikvah Redefines Efficiency and Elegance</h2>
                                        </div>
                                        <div className="story-define-contents">
                                            <p className="description">
                                            Bais Fraida Belz Mikvah, a renowned institution in the heart of Jerusalem, caters to an exceptional volume of nightly patrons. From the outset, their team prioritized integrating innovative systems to enhance both functionality and the overall user experience. Partnering with Mikvahrsvp, we tailored a comprehensive solution that streamlines operations, ensuring seamless service for hundreds of visitors each night.
                                            </p>
                                            <h6 className="required-heading">The Need</h6>
                                            <p className="description">
                                            With 50 rooms and the ability to host 3–4 patrons per room nightly, Bais Fraida needed a highly adaptable system that could handle significant volume while maintaining privacy and a sense of serenity. Additionally, recognizing that most patrons do not use smartphones, the mikvah required a reservation process that would work seamlessly via phone scheduling while still integrating with the rest of the system. To cater to a range of preferences, the mikvah also features a number of VIP rooms with private borot, which required an additional layer of system customization for exclusive access and scheduling.
                                            </p>
                                            <div className="main-story-content">
                                                <div className="story-content-bg">
                                                    <div className="story-content-items">
                                                        <p>
                                                        “Mikvahrsvp transformed the way we run the mikvah. It’s so intuitive for our patrons and makes managing even the busiest nights smooth and organized.”
                                                        </p>
                                                        <span>
                                                            — Sarah G. <br />
                                                            <span>Mikvah Manager at Bais Fraida</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 className="required-heading">The Solution</h6>
                                            <p className="description">
                                              Bais Fraida implemented a highly customized Mikvahrsvp system designed to accommodate their unique needs:
                                            </p>
                                            <ul className="mb-2">
                                                <li>Phone-Friendly Reservations: A bespoke scheduling solution was created to allow patrons to book appointments via phone, with the system automatically integrating these reservations into the overall schedule.</li>
                                                <li>Personalized Music Selection: Patrons can choose their preferred music in the prep rooms, creating a calming environment tailored to their preferences.</li>
                                                <li>VIP Room Management: The system was designed to manage exclusive bookings for the VIP rooms with private borot, ensuring these spaces are reserved and prepared for guests.</li>
                                                <li>Interactive Prep Room Tablets: These devices not only assist with prep but also include prompts to confirm key halachic milestones, like completing a hefsek tahara on the correct date.</li>
                                            </ul>
                                            <p>The system also seamlessly manages the flow of patrons through automated room assignments, live updates for staff, and advanced scheduling features to optimize the mikvah’s capacity.</p>
                                            <h6 className="required-heading">The Results</h6>
                                            <p className="description">
                                              Since implementing Mikvahrsvp, Bais Fraida has revolutionized its nightly operations. The system has drastically improved patron satisfaction and operational efficiency, ensuring the mikvah runs effortlessly every evening. Highlights include:
                                            </p>
                                            <ul>
                                                <li>Streamlined Operations: Patrons easily check themselves in and are guided to the next available room.</li>
                                                <li>Enhanced Privacy: The automated system eliminates the need for extensive staff interaction, allowing visitors a private, dignified experience.</li>
                                                <li>Effortless VIP Room Integration: The exclusive borot rooms are efficiently managed, maintaining their elevated standard of service without disrupting the larger system.</li>
                                                <li>Improved Staff Efficiency: Live dashboards keep attendants informed, helping them manage the flow with ease.</li>
                                            </ul>
                                        </div>
                                        {/* <MikvahSlider /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CustomerStory